 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"ActiveQuestions~AppLayout~Article~Articles~Campaign~CampaignDetail~CampaignRecords~Consumption~Consu~7d2cb3d3":"ActiveQuestions~AppLayout~Article~Articles~Campaign~CampaignDetail~CampaignRecords~Consumption~Consu~7d2cb3d3","ActiveQuestions~AppLayout~Campaign~CampaignRecords~Consumption~Error~Home~NotificationBar~QA~ScanErr~4515e6e3":"ActiveQuestions~AppLayout~Campaign~CampaignRecords~Consumption~Error~Home~NotificationBar~QA~ScanErr~4515e6e3","ActiveQuestions":"ActiveQuestions","AppLayout~AppointStoreMap~Home~Notification~NotificationBar~Profile~QA~Stores":"AppLayout~AppointStoreMap~Home~Notification~NotificationBar~Profile~QA~Stores","AppLayout":"AppLayout","Home":"Home","QA":"QA","Campaign":"Campaign","CampaignRecords":"CampaignRecords","Consumption":"Consumption","Profile~Scanner~StampCard":"Profile~Scanner~StampCard","StampCard":"StampCard","Notification":"Notification","Profile":"Profile","Article":"Article","Articles":"Articles","CampaignDetail":"CampaignDetail","ConsumptionResult":"ConsumptionResult","MyStampCards":"MyStampCards","PointList":"PointList","Record":"Record","StoreStamps":"StoreStamps","Transfer":"Transfer","TransferResult":"TransferResult","NotificationBar":"NotificationBar","Error":"Error","ScanError":"ScanError","Turntable":"Turntable","AppointStore~AppointStoreMap":"AppointStore~AppointStoreMap","AppointStoreMap":"AppointStoreMap","Stores":"Stores","AppointStore":"AppointStore","Coupon":"Coupon","Footer":"Footer","ProfileEdit":"ProfileEdit","Scanner":"Scanner","Service":"Service","StoreInfo":"StoreInfo","Video":"Video"}[chunkId]||chunkId) + "." + {"ActiveQuestions~AppLayout~Article~Articles~Campaign~CampaignDetail~CampaignRecords~Consumption~Consu~7d2cb3d3":"04963120","ActiveQuestions~AppLayout~Campaign~CampaignRecords~Consumption~Error~Home~NotificationBar~QA~ScanErr~4515e6e3":"403ac7bd","ActiveQuestions":"38602488","AppLayout~AppointStoreMap~Home~Notification~NotificationBar~Profile~QA~Stores":"23f2ab71","AppLayout":"1ff85a3f","Home":"a86432a4","QA":"39936b29","Campaign":"55c239bb","CampaignRecords":"961c79c2","Consumption":"93fee4ea","Profile~Scanner~StampCard":"dfa4df6c","StampCard":"9e8bddff","Notification":"1fc6ce7e","Profile":"2dd5b987","Article":"5cec2499","Articles":"88eac63a","CampaignDetail":"aead2d72","ConsumptionResult":"1ec7b61e","MyStampCards":"90a0168d","PointList":"0d539553","Record":"0353f2da","StoreStamps":"a7709888","Transfer":"f9ef5bcd","TransferResult":"ad9359f0","NotificationBar":"e3a7949b","Error":"239620c3","ScanError":"e868d81c","Turntable":"05787edf","AppointStore~AppointStoreMap":"3a04ef0f","AppointStoreMap":"fbb3a8f1","Stores":"d689d8e4","AppointStore":"2a679e3d","Coupon":"9aa3b244","Footer":"0e66987e","ProfileEdit":"2a31921e","Scanner":"0c3e0b71","Service":"97fdb0d1","StoreInfo":"100b8ca4","Video":"e3ad132d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"ActiveQuestions~AppLayout~Campaign~CampaignRecords~Consumption~Error~Home~NotificationBar~QA~ScanErr~4515e6e3":1,"Profile":1,"Turntable":1,"AppointStoreMap":1,"AppointStore":1,"Scanner":1,"StoreInfo":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"ActiveQuestions~AppLayout~Article~Articles~Campaign~CampaignDetail~CampaignRecords~Consumption~Consu~7d2cb3d3":"ActiveQuestions~AppLayout~Article~Articles~Campaign~CampaignDetail~CampaignRecords~Consumption~Consu~7d2cb3d3","ActiveQuestions~AppLayout~Campaign~CampaignRecords~Consumption~Error~Home~NotificationBar~QA~ScanErr~4515e6e3":"ActiveQuestions~AppLayout~Campaign~CampaignRecords~Consumption~Error~Home~NotificationBar~QA~ScanErr~4515e6e3","ActiveQuestions":"ActiveQuestions","AppLayout~AppointStoreMap~Home~Notification~NotificationBar~Profile~QA~Stores":"AppLayout~AppointStoreMap~Home~Notification~NotificationBar~Profile~QA~Stores","AppLayout":"AppLayout","Home":"Home","QA":"QA","Campaign":"Campaign","CampaignRecords":"CampaignRecords","Consumption":"Consumption","Profile~Scanner~StampCard":"Profile~Scanner~StampCard","StampCard":"StampCard","Notification":"Notification","Profile":"Profile","Article":"Article","Articles":"Articles","CampaignDetail":"CampaignDetail","ConsumptionResult":"ConsumptionResult","MyStampCards":"MyStampCards","PointList":"PointList","Record":"Record","StoreStamps":"StoreStamps","Transfer":"Transfer","TransferResult":"TransferResult","NotificationBar":"NotificationBar","Error":"Error","ScanError":"ScanError","Turntable":"Turntable","AppointStore~AppointStoreMap":"AppointStore~AppointStoreMap","AppointStoreMap":"AppointStoreMap","Stores":"Stores","AppointStore":"AppointStore","Coupon":"Coupon","Footer":"Footer","ProfileEdit":"ProfileEdit","Scanner":"Scanner","Service":"Service","StoreInfo":"StoreInfo","Video":"Video"}[chunkId]||chunkId) + "." + {"ActiveQuestions~AppLayout~Article~Articles~Campaign~CampaignDetail~CampaignRecords~Consumption~Consu~7d2cb3d3":"31d6cfe0","ActiveQuestions~AppLayout~Campaign~CampaignRecords~Consumption~Error~Home~NotificationBar~QA~ScanErr~4515e6e3":"0ac4607f","ActiveQuestions":"31d6cfe0","AppLayout~AppointStoreMap~Home~Notification~NotificationBar~Profile~QA~Stores":"31d6cfe0","AppLayout":"31d6cfe0","Home":"31d6cfe0","QA":"31d6cfe0","Campaign":"31d6cfe0","CampaignRecords":"31d6cfe0","Consumption":"31d6cfe0","Profile~Scanner~StampCard":"31d6cfe0","StampCard":"31d6cfe0","Notification":"31d6cfe0","Profile":"b71ad8dd","Article":"31d6cfe0","Articles":"31d6cfe0","CampaignDetail":"31d6cfe0","ConsumptionResult":"31d6cfe0","MyStampCards":"31d6cfe0","PointList":"31d6cfe0","Record":"31d6cfe0","StoreStamps":"31d6cfe0","Transfer":"31d6cfe0","TransferResult":"31d6cfe0","NotificationBar":"31d6cfe0","Error":"31d6cfe0","ScanError":"31d6cfe0","Turntable":"3c7fb030","AppointStore~AppointStoreMap":"31d6cfe0","AppointStoreMap":"166d5d12","Stores":"31d6cfe0","AppointStore":"230f5b0f","Coupon":"31d6cfe0","Footer":"31d6cfe0","ProfileEdit":"31d6cfe0","Scanner":"d00e7915","Service":"31d6cfe0","StoreInfo":"82800b20","Video":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
